import { render, staticRenderFns } from "./playboxscore.vue?vue&type=template&id=202a8d07"
import script from "./playboxscore.vue?vue&type=script&lang=js"
export * from "./playboxscore.vue?vue&type=script&lang=js"
import style0 from "./playboxscore.vue?vue&type=style&index=0&id=202a8d07&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports